import { ApiResource } from './api-resource';
import { HttpClient } from '@angular/common/http';

export type SearchQuery = string;

export type HttpOptions = Exclude<
  Parameters<typeof HttpClient.prototype.get>[1],
  undefined
>;

export interface ApiQueryParams<T extends ApiResource<T>> {
  page?: PaginationQuery;
  search?: SearchQuery;
  filters?: FilterQuery;
  sorts?: SortQuery[];
}

export interface PaginationQuery {
  page?: number;
  limit?: number;
}

export type SortQuery = [field: string, direction: 'ASC' | 'DESC'];
type Primitive = boolean | string | number | Date | null;

export type Filter =
  | [FilterOperator, Primitive | Primitive[]]
  | Primitive
  | Primitive[];
export type FilterQuery = Record<string, Filter | Filter[] | undefined>;

export enum FilterOperator {
  /** LIKE operator (case insensitive) */
  LIKE = '$ilike',
  /** Equal operator */
  EQ = '$eq',
  /** Null */
  NULL = '$null',
  /** Greater Than operator */
  GT = '$gt',
  /** Greater Than Or Equal operator */
  GTE = '$gte',
  /** Less Than operator */
  LT = '$lt',
  /** Less Than Or Equal operator */
  LTE = '$lte',
  /** Between operator */
  BTW = '$btw',
  /** In operator */
  IN = '$in',
  /** Contains operator */
  CONTAINS = '$contains',
}

export enum FilterSuffix {
  NOT = '$not',
  OR = '$or',
  AND = '$and',
}

export type FilterCommand = FilterOperator | [FilterSuffix, FilterOperator];

export function isQueryOperator(input: unknown): input is FilterOperator {
  return (
    typeof input === 'string' &&
    Object.values<string>(FilterOperator).includes(input)
  );
}

export function isQuerySuffix(input: unknown): input is FilterSuffix {
  return (
    typeof input === 'string' &&
    Object.values<string>(FilterSuffix).includes(input)
  );
}

export function mergeApiParams<T extends ApiResource<T>>(
  paramsA: ApiQueryParams<T> | undefined,
  paramsB: ApiQueryParams<T> | undefined,
) {
  return {
    ...paramsA,
    ...paramsB,
    page: { ...paramsA?.page, ...paramsB?.page },
    filters: { ...paramsA?.filters, ...paramsB?.filters },
  };
}

export function mergeDefaultParams<T extends ApiResource<T>>(
  params?: ApiQueryParams<T>,
) {
  return mergeApiParams(
    {
      page: { limit: 20, page: 1 },
    },
    params,
  );
}

export function getCommandOperator(command: FilterCommand): FilterOperator {
  if (Array.isArray(command)) return command[1];
  return command;
}
